import { api } from 'api'
import { StatusForCompanyEnum } from 'api/enums'

type GetWorkerProfileResponse = {
  id: number
  name: string
  worker: {
    id: number
    name?: string
    status?: string
    shadowBlocked: boolean
    rating?: number
    backgroundCheckStatus?: string
    firstActive?: Date
    favorites: number
    profilePicUrl?: string
    address?: {
      city?: string
      state?: string
    }
    numPaidShifts?: number
    numFinishedShifts?: number
    numShiftsForCompany?: number
    numHoursForCompany?: number
    numHoursForCompanyPastWeek?: number
    statusForCompany?: StatusForCompanyEnum | null
    positionTemplateBlocks: {
      id: string
      positionTemplateId: number
      name: string
      blocked: boolean
    }[]
    rosters?: {
      id: string
      name?: string
    }[]
    workProfile?: {
      hasCar?: boolean
      hasLicense?: boolean
      workExperience: {
        id: string
        experience?: string
        startedAt?: Date
        endedAt?: Date
        companyName?: string
        skills?: string
      }[]
    }
  }
}

export async function getWorkerProfile(workerId: number) {
  const response = await api.post<GetWorkerProfileResponse>(
    '/company/graphql_dispatch/worker_profile_a166b359',
    {
      workerId,
    }
  )

  return {
    companyId: response.data.id,
    companyName: response.data.name,
    worker: response.data.worker,
  }
}
